<template>
  <div @click="selectedItem = null">
    <breadcrumbs home="Formula"/>

      <v-card flat>
        <v-form v-model="valid" ref="form">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Name" v-model="formula.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
              </v-col>
              <v-col cols="2">
                <v-checkbox label="Active" v-model="formula.active" dense class="mt-1"/>
              </v-col>
            </v-row>

            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <v-select :items="[{text:'Spirit',value:'SpiritsReductionBulkSpiritsReturnedToSpiritProduction'},
//                                    {text:'Wine',value:'WineReductionNonDutyPaid'},   // TODO: Finish implementation
                                    {text:'Approved formulation',value:'UserSpiritsReductionFormulationOther'},{divider:true},
                                    {text:'Denatured alcohol - DA-2F',value:'SpiritsReductionDenaturedSpiritsFuelDA2F'},
                                    {text:'Denatured alcohol - DA-2G',value:'SpiritsReductionDenaturedSpiritsFuelDA2G'},
                                    {text:'Denatured alcohol - Other grades',value:'SpiritsReductionDenaturedSpiritsOther'},
                                    {text:'Specially denatured alcohol',value:'SpiritsReductionSpeciallyDenaturedSpirits'},
    /*
                                    {divider:true},
                                    {text:'Other non-excise',value:'None'}
                                    */]"
                          @change="formula.outputId=''"
                          label="Produces" v-model="formula.excise" outlined dense/>
              </v-col>
              <v-col cols="6" sm="3" md="2" v-if="formula.excise==='UserSpiritsReductionFormulationOther'">
                <v-text-field label="Formula number" v-model="formula.approvedFormulation" :rules="[requiredFormula,fieldRules.maxLength(10)]" :counter="10" outlined dense />
              </v-col>
              <v-col cols="12" sm="6" class="text-caption mt-n6" v-else-if="!['SpiritsReductionBulkSpiritsReturnedToSpiritProduction','WineReductionNonDutyPaid'].includes(formula.excise)">
                <a href="https://laws-lois.justice.gc.ca/eng/regulations/sor-2005-22/FullText.html" target="_blank">Denatured and Specially Denatured Alcohol Regulations</a>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete v-show="formula.excise==='SpiritsReductionBulkSpiritsReturnedToSpiritProduction'"
                                label="Blend to produce spirit"
                                dense outlined v-model="formula.outputId" :rules="[fieldRules.required]"
                                no-data-text="No spirits found"
                                :items="spirits" item-text="name" item-value="id">
                  <template v-slot:prepend-item>
                    <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="inputItem=null;spiritCreate=true">
                      <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new spirit
                    </div>
                  </template>
                </v-autocomplete>
                <v-autocomplete v-show="formula.excise==='WineReductionNonDutyPaid'"
                                label="Blend to produce wine"
                                dense outlined v-model="formula.outputId" :rules="[fieldRules.required]"
                                no-data-text="No wines found"
                                :items="wines" item-text="name" item-value="id">
                  <template v-slot:prepend-item>
                    <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="inputItem=null;wineCreate=true">
                      <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new wine
                    </div>
                  </template>
                </v-autocomplete>
                <v-autocomplete v-show="!['SpiritsReductionBulkSpiritsReturnedToSpiritProduction','WineReductionNonDutyPaid'].includes(formula.excise)"
                                label="Blend to non-excise"
                                dense outlined v-model="formula.outputId" :rules="[fieldRules.required]"
                                no-data-text="No non-excise found"
                                :items="nonExcises" item-text="name" item-value="id">
                  <template v-slot:prepend-item>
                    <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="inputItem=null;nonExciseCreate=true">
                      <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new non-excise
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="10" sm="4" lg="3" v-if="formula.excise !== 'WineReductionNonDutyPaid'  ">
                <v-switch label="Blend per 1 litre produced" class="ml-1 mt-1" v-model="formula.blendToVolume"/>
              </v-col>
              <v-col cols="6" sm="3" lg="2" v-if="formula.blendToVolume && formula.excise==='SpiritsReductionBulkSpiritsReturnedToSpiritProduction'">
                <decimal-number-input
                      label="Strength" v-model="formula.blendStrength" prefix="" suffix="% alc./vol."
                      :max="99" :min="0"
                      :precision="2" class="text-body-2"/>
              </v-col>
              <v-col cols="6" sm="3" lg="2" v-else-if="!formula.blendToVolume">
                <decimal-number-input
                      label="Tolerance" v-model="formula.percentTolerance" prefix="±" suffix="% LAA"
                      :max="99" :min="0"
                      :precision="1" class="text-body-2"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="9">
                <outlined-block title="Formula inputs" :error-messages="inputsError">
                  <v-data-table width="100%" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                                :items="formula.inputs" item-key="key" no-data-text="At least one input item is required"
                                :headers="[{text:'',value:'add',width:'10%',align:'center',cellClass:'pa-0',divider:true},
                                          {text:'Input',value:'inputType',width:'36%',divider:true,class:'pl-2',cellClass:'py-2 px-1'},
                                          {text:'Quantity',value:'value',width:'18%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'},
                                          {text:'Minimum',value:'minQuantity',width:'18%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'},
                                          {text:'Max (0 for no max)',value:'maxQuantity',width:'18%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'}]"
                                class="no-sort"
                                :item-class="item => item.key=== selectedItem ? ($vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4') : ''"
                                @click.native.stop=""
                                @click:row="item => {selectedItem = item.key; $nextTick(() => this.$refs.form.validate())}"
                                ref="itemTableInputs">
                    <template v-slot:item.add="{item,index}">
                      <v-icon class="handle mt-n2">mdi-drag</v-icon>
                      <v-btn class="mt-n2" icon @click.stop="deleteItem(index)" x-small><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <template v-slot:item.inputType="{item}">
                      <multi-level-select v-if="selectedItem === item.key" :menuData="inputTypes" :first.sync="item.type" :second.sync="item.id"
                                    @change="changeType(item)"
                                    @addSpirit="inputItem=item;spiritCreate=true"
                                    @addWine="inputItem=item;wineCreate=true"
                                    @addNonExcise="inputItem=item;nonExciseCreate=true"
                                    @addItem="inputItem=item;itemCreate=true" autofocus outlined label="Input"/>
                      <div v-else class="pl-1" :class="{'error--text':!item.type}">
                        {{itemDescription(item)}}
                      </div>
                    </template>
                    <template v-slot:item.value="{item}">
                      <template v-if="selectedItem === item.key">
                        <decimal-number-input
                              label="Quantity" v-model="item.quantity" prefix=""
                              :suffix="quantitySuffix(item)"
                              :max="item.type!=='Item'?(formula.blendToVolume?1:100):(item.maxQuantity?item.maxQuantity:undefined)"
                              :min="item.type!=='Item'?0:item.minQuantity"
                              :precision="precision(item)" class="text-body-2" @change="checkInputs"/>
                        <decimal-number-input v-if="formula.blendToVolume && item.type!=='Item'"
                              label="Strength" v-model="item.strength" prefix="" suffix="% alc./vol."
                              :max="99" :min="0"
                              :precision="2" class="text-body-2" @change="checkInputs"/>
                      </template>
                      <div v-else class="mr-2" :class="{'error--text':item.quantity < (item.type!=='Item'?0:item.minQuantity) || (item.quantity > (item.type!=='Item'?(formula.blendToVolume?1:100):(item.maxQuantity?item.maxQuantity:Number.MAX_VALUE)))}">
                        {{item.quantity | number(precision(item))}} {{quantitySuffix(item)}}
                        <div v-if="formula.blendToVolume && item.type!=='Item'" class="text-caption">{{item.strength | number(2)}}% alc./vol.</div>
                      </div>
                    </template>
                    <template v-slot:item.minQuantity="{item}">
                      <template v-if="item.type=='Item'">
                        <decimal-number-input v-if="selectedItem === item.key" label="Min quantity" v-model="item.minQuantity" prefix=""
                              :suffix="quantitySuffix(item)" :precision="precision(item)" class="text-body-2"
                              @change="$refs.form.validate()"/>
                        <div v-else class="mr-2" :class="{'error--text':item.minQuantity < 0}">{{item.minQuantity | number(precision(item))}} {{quantitySuffix(item)}}</div>
                      </template>
                    </template>
                    <template v-slot:item.maxQuantity="{item}">
                      <template v-if="item.type=='Item'">
                        <decimal-number-input v-if="selectedItem === item.key" label="Max quantity" v-model="item.maxQuantity" prefix=""
                              :suffix="quantitySuffix(item)" :precision="precision(item)" class="text-body-2"
                              @change="$refs.form.validate()" hint="0 for no max"/>
                        <div v-else class="mr-2" :class="{'error--text':item.maxQuantity < 0}">{{item.maxQuantity | number(precision(item))}} {{quantitySuffix(item)}}</div>
                      </template>
                    </template>
                    <template v-slot:footer="{widths}">
                      <v-divider/>
                      <div @click="selectedInputItem = null" style="width:100%" class="py-2 px-0">
                        <div :style="'width:'+widths[0]+'px'" class="text-center">
                          <v-btn :disabled="formula.inputs.some(input => !input.id)" fab color="primary" x-small @click.stop="addItem"><v-icon small>mdi-plus</v-icon></v-btn>
                        </div>
                      </div>
                    </template>
                  </v-data-table>
                </outlined-block>
              </v-col>
            </v-row>

            <v-row class="mt-2" v-if="!formula.blendToVolume && formula.excise !== 'WineReductionNonDutyPaid'">
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete dense outlined label="Scale input items to" hide-details
                          :items="inputAlcohol" item-value="id" item-text="name" v-model="formula.scaleToId"
                          :disabled="noItemsInput"/>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <decimal-number-input label="Base LAA" v-model="formula.scaleBase" prefix="" suffix="LAA" :precision="3"
                                      :disabled="!formula.scaleToId"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-textarea label="Production notes" v-model="formula.description" outlined dense no-resize :rows="4" :rules="[fieldRules.maxLength(1000)]"/>
              </v-col>
            </v-row>
            <v-row v-if="$store.getters.company.allowPlanning">
              <v-col cols="12" md="6">
                <production-planning :planning="formula.productionPlanningInfo"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-divider/>
        <v-card-actions class="px-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
    <spirit-quick-create v-model="spiritCreate" @create="spiritCreated"/>
    <alcohol-non-excise-quick-create v-model="nonExciseCreate" @create="nonExciseCreated"/>
    <wine-quick-create v-model="wineCreate" @create="wineCreated"/>
    <inventory-items-quick-create v-model="itemCreate" @create="itemCreated"/>
  </div>
</template>

<script>
import sortableJS from 'sortablejs';
import SpiritQuickCreate from '@/views/alcohol/spirits/SpiritQuickCreate'
import AlcoholNonExciseQuickCreate from '@/views/alcohol/nonExcise/AlcoholNonExciseQuickCreate'
import WineQuickCreate from '@/views/alcohol/wine/WineQuickCreate'
import InventoryItemsQuickCreate from '@/views/inventory/items/InventoryItemsQuickCreate'
import confirmLeave from '@/mixins/confirmLeave'
import ProductionPlanning from '@/views/production/ProductionPlanning'
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'ProductionBlendingFormulasEdit',
  mixins: [confirmLeave,createHierarchyList],
  components: {SpiritQuickCreate,AlcoholNonExciseQuickCreate,WineQuickCreate,InventoryItemsQuickCreate,ProductionPlanning},
  props: {
    formulaId: {type:String, required:false},
    copy: {type:Boolean, required:false}
  },
  data () {
    return {
      formula: {inputs:[],productionPlanningInfo:{equipmentTypes:[]}},
      items: [],
      categories: [],
      spirits: [],
      nonExcises: [],
      wines: [],
      totalPercent: 0,
      dirty: false,
      saving: false,
      loading: false,
      valid: true,
      selectedItem: null,
      inputsError: null,
      requiredFormula: v => this.formula.excise !== 'UserSpiritsReductionFormulationOther' ||  !!v || 'Required',
      spiritCreate: false,
      nonExciseCreate: false,
      itemCreate: false,
      wineCreate: false,
      inputItem: null,
      sortable: null
    }
  },
  computed: {
    inputAlcohol() {
      const spirits = this.spirits.filter(spirit => this.formula.inputs.some(i => i.type === 'Spirit' && i.id === spirit.id));
      const wines = this.wines.filter(wine => this.formula.inputs.some(i => i.type === 'Wine' && i.id === wine.id));
      const nonExcises = this.nonExcises.filter(nonExcise => this.formula.inputs.some(i => i.type === 'NonExcise' && i.id === nonExcise.id));
      return [{id:'',name:'(no scaling)'},{divider:true},...spirits,...wines,...nonExcises];
    },
    noItemsInput() {
      return !this.formula.inputs.some(i => i.type === 'Item' || i.type === 'Non-excise');
    },
    inputTypes() {
      const types = [];
      if (this.formula.excise !== 'WineReductionNonDutyPaid')
        types.push({name:'Spirit',id:'Spirit',menu:this.spirits,actionEvent:'addSpirit',actionText:'Add new spirit'});
      types.push({name:'Wine',id:'Wine',menu:this.wines,actionEvent:'addWine',actionText:'Add new wine'});
      if (this.formula.excise !== 'WineReductionNonDutyPaid')
        types.push({name:'Non-excise',id:'Non-excise',menu:this.nonExcises,actionEvent:'addNonExcise',actionText:'Add new non-excise'});
      if (this.categories.length) {
        const categories = this.createHierarchyList(this.categories);
        for (const category of categories) {
          const sub = this.items.filter(item => item.category?.id === category.id);
          if (sub.length)
            category.menu = sub;
          else
            category.disabled = true;
        }
        const otherItems = {name:'Other items',id:'x'};
        const leftOver = this.items.filter(item => !item.category?.id);
        if (leftOver.length)
          otherItems.menu = leftOver;
        else
          otherItems.disabled = true;
//        types.push({name:'Item',id:'Item',menu:[...categories.filter(category => !category.disabled), {divider:true}, otherItems],actionEvent:'addItem',actionText:'Add new item'});
        types.push({name:'Item',id:'Item',menu:[...categories, {divider:true}, otherItems],actionEvent:'addItem',actionText:'Add new item'});
      }
      else
        types.push({name:'Item',id:'Item',menu:this.items,actionEvent:'addItem',actionText:'Add new item'});
      return types;
    }
  },
  watch: {
    formula: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    },
    inputAlcohol() {
      if (this.formula.scaleToId && !this.inputAlcohol.some(a => a.id === this.formula.scaleToId))
        this.formula.scaleToId = '';
    }
  },
  async created() {
    this.loading = true;
    const load = [this.$lazyListLoad(this.categories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Item'}]),
                  this.$lazyListLoad(this.items, 'items2', 'id,name,trackUnits,precision,category{id}', 100, !this.formulaId ? [{field:'active', comparator:'eq', value:'true'}] : []),
                  this.$lazyListLoad(this.spirits, 'spirits2', 'id,name', 100, this.formulaId ? [] : [{field:'active', comparator:'eq', value:'true'}]),
                  this.$lazyListLoad(this.nonExcises, 'nonExcises2', 'id,name', 100, this.formulaId ? [] : [{field:'active', comparator:'eq', value:'true'}])
                  ];
    if (this.$store.getters.company.allowWine)
      load.push(this.$lazyListLoad(this.wines, 'wines2', 'id,name', 100, this.formulaId ? [] : [{field:'active', comparator:'eq', value:'true'}]));
    await Promise.all(load);

    if (this.formulaId) {
      const results = await this.$apiCall(`query ProductionBlendingFormulasEdit($id:ID!) {
                                                formula(id:$id) {
                                                  id,name,active,outputId,approvedFormulation,excise
                                                  blendToVolume,blendStrength,percentTolerance,
                                                  inputs{type,id,quantity,strength,minQuantity,maxQuantity},scaleToId,scaleBase,description
                                                  productionPlanningInfo {useAverageDuration,specifiedDuration,equipmentTypes{id,quantity},roleId}
                                                }
                                              }`,
                                          {id:this.formulaId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.formula = results.data.formula;
      let key = Date.now();
      this.formula.inputs.forEach(input => {input.key = key++, input.type = input.type === 'NonExcise' ? 'Non-excise' : input.type});
      if (this.copy) {
        delete this.formula.id;
        this.formula.active = true;
        this.formula.name = `COPY OF ${this.formula.name}`;
      }
    }

    else
      this.formula = {name:'',active:true,inputs:[],outputId:'',approvedFormulation:'',excise:'SpiritsReductionBulkSpiritsReturnedToSpiritProduction',
                      scaleToId:'',scaleBase:0,description:'',blendToVolume:false, blendStrength:7,percentTolerance:0,
                      productionPlanningInfo:{useAverageDuration:true,specifiedDuration:0,equipmentTypes:[],roleId:''}};

    this.$nextTick(() => this.dirty = false);
    this.checkInputs();
    this.loading = false;
  },
  mounted() {
    setTimeout(() => {
      if (!this.$refs.itemTableInputs)
        return;
      const _self = this;
      this.sortable = sortableJS.create(this.$refs.itemTableInputs.$el.querySelector('tbody'), {
        handle: '.handle',
        onEnd({newIndex, oldIndex}) {
          const rowSelected = _self.formula.inputs.splice(oldIndex, 1)[0];
          _self.formula.inputs.splice(newIndex, 0, rowSelected);
        }
      })
    }, 1000);
  },
  beforeDestroy() {
    this.sortable.destroy();
  },

  methods: {
    itemDescription(item) {
      if (!item.type)
        return 'MISSING';
      const lists = {'Spirit':this.spirits,'Wine':this.wines,'Non-excise':this.nonExcises,'Item':this.items};
      return `${item.type}: ${lists[item.type]?.find(i => i.id === item.id || i.id === item.spiritId)?.name}`;
    },
    toggleFormulaType() {
      if (this.formula.approvedFormulation)
        this.formula.outputId = this.items.length ? this.items[0].id : '';
      else
        this.formula.outputId = this.spirits.length ? this.spirits[0].id : ''
      this.$refs.form.validate();
    },
    checkInputs() {
      this.inputsError = null;
      if (this.formula.blendToVolume)
        return;
      const percent = this.formula.inputs.reduce((total, item) => total + (item.type !== 'Item' ? item.quantity : 0), 0);
      if (this.$roundNumber(percent,1) !== 100)
        this.inputsError = 'Alcohol inputs must total to 100% LAA';
      this.$nextTick(() => this.$refs.form.validate());
    },
    spiritCreated(spirit) {
      this.spirits.push(spirit);
      if (this.inputItem) {
        this.inputItem.id = spirit.id;
        this.inputItem.type = 'Spirit';
      }
      else
        this.formula.outputId = spirit.id;
    },
    nonExciseCreated(nonExcise) {
      this.nonExcises.push(nonExcise);
      if (this.inputItem) {
        this.inputItem.id = nonExcise.id;
        this.inputItem.type = 'Non-excise';
      }
      else
        this.formula.outputId = nonExcise.id;
    },
    async itemCreated(item) {
      this.items = (await this.$store.dispatch('items')).filter(item => item.active);
      if (this.inputItem) {
        this.inputItem.id = item.id;
        this.inputItem.type = 'Item';
      }
    },
    wineCreated(wine) {
      this.wines.push(wine);
      if (this.inputItem) {
        this.inputItem.id = wine.id;
        this.inputItem.type = 'Wine';
      }
    },
    changeType(item) {
      item.minQuantity = 0;
      item.maxQuantity = 0;
      item.quantity = 0;
      this.checkInputs();
    },
    precision(item) {
      if (item.type !== 'Item')
        return this.formula.blendToVolume ? 3 : 1;
      if (!item.id)
        return;
      return this.items.find(i => i.id === item.id)?.precision || 0;
    },
    quantitySuffix(item) {
      if (this.formula.excise === 'WineReductionNonDutyPaid' && item.type === 'Wine')
        return '%';
      if (item.type !== 'Item')
        return this.formula.blendToVolume ? 'litres' : '% LAA';
      if (!item.id)
        return;
      return this.items.find(i => i.id === item.id)?.trackUnits || '';
    },
    addItem() {
      const key = Date.now();
      this.formula.inputs.push({key,type:'',id:null,quantity:0,strength:0,minQuantity:0,maxQuantity:0});
      this.selectedItem = key;
      this.checkInputs();
    },
    deleteItem(index) {
      this.formula.inputs.splice(index, 1);
      this.checkInputs();
    },
    cancel() {
      this.$router.back();
    },
    async save() {
      const incomplete = this.formula.inputs.some(item => !item.type ||
                                                          item.quantity < (item.type !== 'Item' ? 0 : item.minQuantity) ||
                                                          item.quantity > (item.type !== 'Item' ? (this.formula.blendToVolume?1:100) : (item.maxQuantity ? item.maxQuantity : Number.MAX_VALUE)) ||
                                                          item.minQuantity < 0 || item.maxQuantity < 0);
      if (!this.valid || incomplete) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      const input = Object.assign({}, this.formula);
      input.inputs = this.formula.inputs.map(input => {return {type:input.type==='Non-excise'?'NonExcise':input.type,
                                                               id:input.id,strength:input.strength,
                                                               quantity:input.quantity,minQuantity:input.minQuantity,maxQuantity:input.maxQuantity}});
      const results = await this.$apiCall(`mutation ProductionBlendingFormulasEdit($input: FormulaInput!) {
                                             formulaCreate(input:$input) {id}
                                           }`,
                                          {input})
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.formula.id?'Updated':'Created'} formula ${this.formula.name}`});
      }
    }
  }
}
</script>